import React from 'react';

import styles from '../CardContent/styles/styles.module.scss';
import CardDuration from '../CardDuration';
import CardName from '../CardName';
import CardLength from '../CardLength';
import CardLocation from '../CardLocation';
import Difficulty from '../../shared/Difficulty';
import StarRating from '../../shared/StarRating';
import ReviewCount from '../../shared/ReviewCount';
import CardDescription from '../CardDescription/CardDescription';
import { getAbbrevDescription, getLocalizedName } from '../../../utils/trail_helpers';

export default function TrailCardContent({
  className,
  context,
  descriptive,
  displayRank,
  forceCityLink,
  handleLocationClick,
  namePaddingRight,
  trail,
  url
}) {
  let name = getLocalizedName(trail, context.languageRegionCode);
  if (displayRank) {
    name = `#${displayRank} - ${name}`;
  }

  const classes = [styles.content];
  if (className) {
    classes.push(className);
  }
  if (descriptive) {
    classes.push(styles.descriptive);
  }

  const displayMetric = context ? context.displayMetric : null;

  let cardDuration;
  if (trail.duration_minutes) {
    cardDuration = (
      <>
        <span>&nbsp;•&nbsp;</span>
        <CardDuration durationInMinutes={trail.duration_minutes || '?'} />
      </>
    );
  }

  return (
    <div className={classes.join(' ')}>
      <CardName name={name} paddingRight={namePaddingRight} />
      <CardLocation
        className={`${styles.info} ${styles.link}`}
        context={context}
        forceCityLink={forceCityLink}
        handleClick={handleLocationClick}
        paddingRight={namePaddingRight}
        trail={trail}
      />
      <div className={`${styles.info} ${styles.thin}`}>
        <Difficulty difficulty={trail.difficulty_rating} />
        <StarRating config={trail.avg_rating} />
        <ReviewCount count={trail.num_reviews} />
      </div>
      <div className={styles.info}>
        <CardLength length={trail.length} displayMetric={displayMetric} />
        {cardDuration}
      </div>
      {descriptive && (
        <CardDescription
          className={styles.description}
          name={trail.name}
          description={getAbbrevDescription(trail, displayMetric)}
          showMoreUrl={url}
        />
      )}
    </div>
  );
}
